<template>
    <div class="mvt-seolink" v-if="sectionVisibility">
        <div class="seo-list" v-if="cityLinks && cityLinks.length">
            <div class="text-bold">{{molang('search.common.cities')}}</div>
            <ul>
                <template v-for="(item, i) in cityLinks" :key="i">
                    <li v-if="item.cityPath">
                        <a class="link" :href="glb.appUrl + getLangPathPrefix + item.cityPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.city, stateCode: item.state })"  :count="item.medianListPrice">
                            <span>{{linkPrefix}} {{item.city}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
        <div class="seo-list" v-if="zipcodeLinks && zipcodeLinks.length">
            <div class="text-bold">{{molang('search.common.zipCodes')}}</div>
            <ul>
                <template v-for="(item, i) in zipcodeLinks" :key="i">
                    <li v-if="item.zipcodePath">
                        <a class="link" :href="glb.appUrl + getLangPathPrefix + item.zipcodePath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.zipcode, stateCode: item.state })" :count="item.medianListPrice">
                            <span>{{linkPrefix}} {{item.zipcode}}{{`, ${item.state}`}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
        <div class="seo-list" v-if="neighborhoodLinks && neighborhoodLinks.length">
            <div class="text-bold">{{molang('search.common.neighborhoods')}}</div>
            <ul>
                <template v-for="(item, i) in neighborhoodLinks" :key="i">
                    <li v-if="item.neighborhoodPath && item.neighborhood">
                        <a class="link" :href="glb.appUrl + getLangPathPrefix + item.neighborhoodPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.neighborhood, stateCode: item.state })"  :count="item.medianListPrice">
                            <span>{{linkPrefix}} {{item.neighborhood}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
        <div class="seo-list" v-if="countyLinks && countyLinks.length">
            <div class="text-bold" v-text="molang('search.common.counties')"></div>
            <ul>
                <template v-for="(item, i) in countyLinks" :key="i">
                    <li v-if="item.countyPath">
                        <a class="link" :href="glb.appUrl + getLangPathPrefix + item.countyPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.county, stateCode: item.state })" :count="item.medianListPrice">
                            <span>{{linkPrefix}} {{item.county}}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script src="./search-seolink.js"></script>

<style lang="scss">
@use './search-seolink.scss' as *;
</style>
